// @flow

import * as React from "react";
import classNames from "classnames";

import "./icon-button.css";

type Props = {
  children: React.Node,
  className?: string,
  icon: React.Node,
};

const IconButton = ({ className, children, icon, ...props }: Props) => (
  <button className={classNames(className, "IconButton")} {...props}>
    <div className="IconButton__icon">{icon}</div>
    <div className="IconButton__content">{children}</div>
  </button>
);

export default IconButton;
